import { render, staticRenderFns } from "./DetailHasilUjianPSIKOTES.vue?vue&type=template&id=d8f9cbaa&scoped=true"
import script from "./DetailHasilUjianPSIKOTES.vue?vue&type=script&lang=js"
export * from "./DetailHasilUjianPSIKOTES.vue?vue&type=script&lang=js"
import style0 from "./DetailHasilUjianPSIKOTES.vue?vue&type=style&index=0&id=d8f9cbaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f9cbaa",
  null
  
)

export default component.exports